export const CIPTableData:any = [];